import { useState, useEffect } from "react";
import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Auspicious.scss";
import Footer from "../../../components/Footer/Footer";
import MuhuratLink from "../../../components/MuhuratLink/MuhuratLink";
import axios from "axios";

const Auspicious = () => {
  const today = new Date();
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth() + 1); // month is 1–12
  const [auspiciousData, setAuspiciousData] = useState([]);
  const [selectedYoga, setSelectedYoga] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async (selectedMonth, selectedYear) => {
    try {
      setLoading(true);
      const [raviRes, sarvarthaRes, amritRes, dwipushkarRes, tripush, raviPushya, gurupushya, maitreya] =
        await Promise.all([
          axios.get(
            `https://core-c343.onrender.com/api/ravi-yoga/${selectedMonth}/${selectedYear}`
          ),
          axios.get(
            `https://core-c343.onrender.com/api/sarvartha-siddhi/${selectedMonth}/${selectedYear}`
          ),
          axios.get(
            `https://core-c343.onrender.com/api/amrit-siddhi/${selectedYear}`
          ),
          axios.get(
            `https://core-c343.onrender.com/api/dwipushkar-yoga/${selectedYear}`
          ),
          axios.get(
            `https://core-c343.onrender.com/api/tripushkar-yoga/${selectedYear}`
          ),
          axios.get(
            `https://core-c343.onrender.com/api/ravi-pushya-yoga/${selectedYear}`
          ),
          axios.get(
            `https://core-c343.onrender.com/api/guru-pushya-yoga/${selectedYear}`
          ),
          axios.get(
            `https://core-c343.onrender.com/api/maitreya-yoga/${selectedYear}`
          ),
        ]);

      const data = [
        { name: "Ravi Yoga", dates: raviRes.data.raviYogaDates },
        { name: "Sarvartha Siddhi Yoga", dates: sarvarthaRes.data.sarvarthaSiddhiDates },
        { name: "Amrit Siddhi Yoga", dates: amritRes.data.amritSiddhiDates },
        { name: "Dwipushkar Yoga", dates: dwipushkarRes.data.dwipushkarYogaDates },
        { name: "Tripushkar Yoga", dates: tripush.data.tripushkarYogaDates },
        { name: "Ravi Pushya Yoga", dates: raviPushya.data.raviPushyaYogaDates },
        { name: "Guru Pushya Yoga", dates: gurupushya.data.guruPushyaYogaDates },
        { name: "Maitreya Yoga", dates: maitreya.data.maitreyaYogaDates },
      ];

      setAuspiciousData(data);
    } catch (error) {
      console.error("Error fetching Yoga data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch when year/month changes
  useEffect(() => {
    fetchData(month, year);
  }, [month, year]);

  return (
    <div className="Auspicious-container">
      <InnerNav />
      <div className="Auspicious-content">
        <Zodiac />

        {/* Control Panel */}
        <div className="control-panel">
          <label>
            Month:
            <select value={month} onChange={(e) => setMonth(Number(e.target.value))}>
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {new Date(0, i).toLocaleString("default", { month: "long" })}
                </option>
              ))}
            </select>
          </label>

          <label>
            Year:
            <input
              type="number"
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
              min="1900"
              max="2100"
            />
          </label>
        </div>

        <div className="aus-header">
          <h3>Auspicious Yoga</h3>
        </div>

        {loading ? (
          <p>Loading data...</p>
        ) : (
          <div className="aus-grid">
            {auspiciousData.map((yoga, index) => (
              <div
                className="aus-card"
                key={index}
                onClick={() => setSelectedYoga(yoga)}
              >
                <div className="aus-img">
                  <img
                    src="https://api.astrosagga.com/uploads/1750504361017.png"
                    alt={yoga.name}
                  />
                </div>
                <h2>{yoga.name}</h2>
              </div>
            ))}
          </div>
        )}

        <section className="yoga-wrapper">
          <h1 className="yoga-title">About Yoga</h1>
          <div className="yoga-texts">
            <p>
              According to Vedic astrology, the auspicious and inauspicious combination formed by the union of Graha, Nakshatra and Tithi is called Yoga. The days of various types of auspicious Yogas like Sarvartha Siddhi Yoga, Amrit Siddhi Yoga, Dwipushkar Yoga, Tripushkar Yoga and Ravi Pushya Yoga are listed here. All these Auspicious Yogas have their own characteristics, due to which the work done during these Yogas gives auspicious results.
            </p>
            <p>
              For example, according to beliefs, the work done in Dwipushkara Yoga is repeated twice and the work done in Tripushkara Yoga is repeated thrice. Similarly, when Pushya Nakshatra falls on Sunday, Ravi Pushya Yoga is formed. Ravi Pushya Yoga is considered very auspicious and beneficial for various types of auspicious works including purchasing precious metals and jewellery etc. Various such auspicious Yogas are listed on this page.
            </p>
          </div>
        </section>

        <MuhuratLink />
      </div>
      <Footer />

      {/* Popup Modal */}
      {selectedYoga && (
        <div className="popup-overlay" onClick={() => setSelectedYoga(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedYoga.name}</h2>
            <ul>
              {selectedYoga.dates.map((date, i) => (
                <li key={i}>{date}</li>
              ))}
            </ul>
            <button onClick={() => setSelectedYoga(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Auspicious;
